/**
 * העמודה הצדדית במסך רחב (6ג, RQ-J11).
 *
 * הניווט של המסך הפתוח — בביקור: רשימת הפרקים, הסיכום והדוחות. המסך מציב שם תוכן
 * דרך `InSideNav` (portal), רק במסך רחב; בטלפון אותו תוכן נשאר במקומו בתוך המסך (A-146).
 * הלשוניות (ביקורים · תיק אתר · חשבון) אינן כאן אלא בסרגל התחתון (BottomBar.tsx, 6ו-ב חלק 3,
 * A-185); כשאין תוכן — העמודה אינה תופסת מקום (`.side:has(> .side-context:empty)`).
 */

import { createContext, useContext, type ReactElement, type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { useWideScreen } from './useWideScreen.ts';

/** האלמנט שבעמודה הצדדית (App.tsx). null — לפני שהשלד הוצב. */
export const SideSlotContext = createContext<HTMLElement | null>(null);

/** האם יש עמודה צדדית עכשיו: מסך רחב, והשלד כבר הוצב. */
export function useSideSlot(): HTMLElement | null {
  const slot = useContext(SideSlotContext);
  const wide = useWideScreen();
  return wide ? slot : null;
}

/** מציב את התוכן בעמודה הצדדית; בלי עמודה (מסך צר) — לא מציג כלום. */
export function InSideNav({ children }: { children: ReactNode }): ReactElement | null {
  const slot = useSideSlot();
  return slot === null ? null : createPortal(children, slot);
}
